<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>account_balance_wallet</mat-icon></div>
    <div class="cfd-header-text">
      <h2 class="cf-dlg-title">{{ isEdit ? 'Editar caja' : 'Nueva caja' }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cancel()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando caja…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Actualizando caja…' : 'Creando caja…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch">
        <mat-icon>error</mat-icon>
        <span>{{ loadError }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <form class="cfd-form" [formGroup]="form" (ngSubmit)="save()" novalidate>
      <div class="cf-dlg-body">
        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <span class="cf-dlg-section__label">Datos de la caja</span>

        <div class="cf-field--required" [class.cf-field--invalid]="hasError('nombre', 'required')">
          <app-field [control]="form.controls.nombre" [config]="nombreConfig"></app-field>
        </div>

        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="hasError('ubicacion', 'required')">
            <app-field [control]="form.controls.ubicacion" [config]="ubicacionConfig"></app-field>
          </div>

          <app-field [control]="form.controls.fondoDeCaja" [config]="fondoConfig"></app-field>
        </div>

        <div class="cfd-uid" *ngIf="entity?.uid">
          <button type="button" class="cfd-link" (click)="showUid = !showUid">
            <mat-icon>{{ showUid ? 'visibility_off' : 'visibility' }}</mat-icon>
            {{ showUid ? 'Ocultar UID' : 'Ver UID' }}
          </button>
          <span class="cfd-uid__value" *ngIf="showUid">{{ entity?.uid }}</span>
        </div>
      </div>

      <div class="cf-dlg-footer">
        <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
        <button type="submit" mat-flat-button class="cf-dlg-btn-primary" [disabled]="saving">
          <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear caja' }}
        </button>
      </div>
    </form>
  </ng-container>
</div>
